import Modal from "components/Modal";

export const extractTitlesFromTemplateJson = (templateJson) => {
    if (!Array.isArray(templateJson)) return [];
    return templateJson
        .map((item) => item?.props?.title ?? item?.title ?? null)
        .filter(Boolean);
};

const ChartTitlesModal = ({ open, onClose, template }) => {
    const titles = template ? extractTitlesFromTemplateJson(template.templateJson) : [];

    return (
        <div className="relative z-[110]">
            <Modal
                open={open}
                className="relative w-[32rem] px-8 py-10 bg-primary-3 text-white rounded-lg text-left"
            >
                <h2 className="text-center text-xl">Chart titles</h2>
                {template && (
                    <p className="text-gray-400 text-sm mt-2 text-center">
                        {template.name ?? "Unnamed template"}
                    </p>
                )}
                <div className="mt-6">
                    {titles.length === 0 ? (
                        <p className="text-gray-400 py-4">No chart titles in this template.</p>
                    ) : (
                        <ul className="space-y-2 max-h-80 overflow-y-auto">
                            {titles.map((title, index) => (
                                <li
                                    key={`${title}-${index}`}
                                    className="px-4 py-3 rounded-lg border border-primary-light bg-primary-3 text-gray-300"
                                >
                                    {title}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
                <div className="flex justify-end mt-6">
                    <button
                        type="button"
                        className="py-2 px-4 border border-gray-200 rounded text-gray-300"
                        onClick={onClose}
                    >
                        Close
                    </button>
                </div>
            </Modal>
        </div>
    );
};

export default ChartTitlesModal;
